import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

import shell from './modules/shell';
import properties from './modules/properties';
import map from './modules/map';
import auth from './modules/auth';
import langSelector from './modules/langSelector';
export const strict = false;

export default new Vuex.Store({
  modules: {
    shell,
    properties,
    map,
    auth,
    langSelector,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js